import { render, staticRenderFns } from "./coffee-quiz-new.vue?vue&type=template&id=58748925&scoped=true&"
import script from "./coffee-quiz-new.vue?vue&type=script&lang=js&"
export * from "./coffee-quiz-new.vue?vue&type=script&lang=js&"
import style0 from "./coffee-quiz-new.vue?vue&type=style&index=0&id=58748925&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58748925",
  null
  
)

export default component.exports